import Vue from 'vue'
import {permission} from '@/directives/permission/permissionUserInfo'

/**
 * 校验用户权限
 * @param options 指定权限校验规则
 * {
 *   type : 允许访问的用户类型 默认允许全部类型访问 (person 个人, company 企业, team 团队, organization 组织)
 *   login : 是否登录后才能访问 默认为true (true false)
 *   realName : 是否实名认证后才能访问 默认为true (true false)
 * }
 * @returns {boolean} 是否拦截
 */
Vue.prototype.permissionTips = function (options) {
  const {userInfo, rule} = permission(options)

  let headOff = false
  // 未登录
  if (rule.login && !userInfo.isLogin) {
    headOff = true
    let data = {
      callBack: function () {
        this.$store.dispatch("setUser")
      }.bind(this)
    }
    Vue.prototype.$_login(data)
  } else if (rule.realName && !userInfo.isRealName) {
    // 未实名
    headOff = true
    Vue.prototype.$message.showPermissionTips('你还未进行实名认证', () => {
      window.open(`${process.env.VUE_APP_PERSONURL}/authenticationRealName`)
    }, false, '去认证')
  } else if (!rule.type.includes(Number(userInfo.type)) && userInfo.type !== undefined) {
    // 无权限
    headOff = true
    Vue.prototype.$message.showPermissionTips('当前身份无权限，请切换身份后重试', () => {
    })
  }

  return headOff
}